<template>
  <b-button size="sm" variant="outline-danger">{{$t('header.cancel')}}</b-button>
</template>
<script>
export default {
  name: 'CancelButton'
}

</script>



// WEBPACK FOOTER //
// src/components/CancelButton.vue